module.exports = __webpack_public_path__ + "img/clock.b73c98e0.svg";